import { get,post } from "../Config";


export function GetCouponType() {
  return get({ url: `/api/impact/v1/couponType` });
}

export function GetCoupon({params}) {
  return get({ url: `/api/impact/v1/allCoupon`,params });
}

export function GetAllCoupon({params}) {
  return get({ url: `/api/impact/v1/couponImpFamily`,params });
}

export function GetCouponById({params}) {
  return get({ url: `/api/impact/v1/couponById`,params });
}

export function PostRedeemCoupon({data}){
    return post({ url: `/api/impact/v1/customer/coupon/redeem`, data });
}

export function GetRedeemCoupon({params}){
    return get({ url: `/api/impact/v1/customer/coupon/redeem`, params });
}